<div class="page-wrapper">
  <div class="grid-row">
    <div class="grid-item grid-col-fill incidents-header">
      <h1>MARS Incidents</h1>
    </div>
  </div>
  <div class="filterContainer">
    <div class="grid-row">
      <div class="grid-item grid-col-fill">
        <div class="filter-box">

          <mat-accordion>
            <mat-expansion-panel  #accordion [expanded]="true" class="main-filter-panel">
              <mat-expansion-panel-header class="main-expansion-header">
                <mat-panel-title>
                  Report Settings
                </mat-panel-title>
              </mat-expansion-panel-header>

          <form [formGroup]="gridForm">
            <h4>Select the types of incidents. Not selecting anything will report all incidents.</h4>
              <div class="grid-row flex-wrap">
                <div class="grid-row">
                  <div class="grid-row">
                    <div class="grid-col">
                      <mat-form-field appearance="fill" class="fs_form-input">
                        <mat-label>Classifications</mat-label>
                        <mat-select (selectionChange)="classificationSelectionChanged($event)" multiple>
                          <mat-option
                            *ngFor="let cls of classificationData"
                            [value]="cls.classificationId"
                            >{{ cls.classificationName }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="grid-col">
                      <mat-form-field appearance="fill" class="fs_form-input">
                        <mat-label>Classification Types</mat-label>
                        <mat-select (selectionChange)="classificationTypeSelectionChanged($event)" multiple>
                            <mat-option *ngFor="let cls of classificationTypeData"
                              [value]="cls.classificationTypeId"
                              >{{ cls.classificationTypeName }}
                            </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="grid-col">
                      <mat-form-field appearance="fill" class="fs_form-input">
                        <mat-label>Categories</mat-label>
                        <mat-select (selectionChange)="categorySelectionChanged($event)" multiple>
                          <mat-option *ngFor="let cat of categoryData"
                            [value]="cat.categoryId"
                            >{{ cat.categoryName }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div *ngIf="true" class="grid-col">
                      <mat-form-field appearance="fill" class="fs_form-input">
                        <mat-label>Malfunction Types</mat-label>
                        <mat-select multiple (selectionChange)="malfunctionTypeChanged($event)">
                          <mat-option
                            *ngFor="let mType of malfunctionTypeComboData"
                            [value]="mType.malfunctionTypeId"
                            >{{ mType.malfunctionTypeName }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                  </div>
                </div>

              </div>

              <h4>Select report columns to display</h4>
              <!-- filters section -->
              <section class="filters-section">
                <div class="grid-row flex-wrap">
                  <div class="grid-row">
                    <!-- SECTION  -->
                    <div *ngFor="let section of formData?.sections; let i = index">
                      <div class="filters-section-label">
                        <p class="filters-section-title">{{ section.header }}</p>
                      </div>
                      <!-- SUBSECTION - gets a 'check all' chebox -->
                      <div *ngFor="let subSection of section.subSections" class="subSection">
                        <mat-accordion>
                          <mat-expansion-panel
                            class="expansion-panel"
                            [expanded]="subSection.selected"
                            [disabled]="true"
                          >
                            <mat-expansion-panel-header>
                              <mat-panel-title class="filters-section-label">
                                <mat-checkbox
                                (change)="setResetCheckboxes(subSection.header, $event)"
                                ></mat-checkbox>
                                  &nbsp;{{ subSection.header }}
                              </mat-panel-title>
                              <button mat-icon-button (click)="subSection.selected = !subSection.selected"> 
                                <mat-icon>keyboard_arrow_down</mat-icon>
                              </button>
                            </mat-expansion-panel-header>

                            <!-- COLUMNS -->
                            <div *ngFor="let column of subSection.columns; let i=index">
                              <span>
                                <ul>
                                  <li>
                                    <mat-checkbox
                                      [id]="column.field"
                                      (change)="onColumnCheckBoxChanged($event, column)"
                                      [checked]="column.selected"
                                    >
                                      {{ column.label }}
                                    </mat-checkbox>
                                  </li>
                                </ul>
                              </span>
                            </div>


                          </mat-expansion-panel>
                        </mat-accordion>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <button
                mat-raised-button
                type="button"
                class="nmis-green-btn float-right report-buttons"
                [disabled]="filterForm.invalid"
                (click)="getData(); accordion.expanded = false"
              >
                Generate Report
              </button>
          </form>

          </mat-expansion-panel>
        </mat-accordion>          

        </div>
      </div>
    </div>
  </div>

  <div class="search-row">
    <mat-form-field class="search-container">
      <mat-label>Filter</mat-label>
      <input [(ngModel)]="filterValue" matInput (keyup)="tableStringFilter($event)" placeholder="Search" #stringinput id="filter-text-box">
    </mat-form-field>
    <button
      mat-raised-button
      type="button"
      class="nmis-green-btn float-right report-buttons"
      [disabled]="filterForm.invalid"
      (click)="downloadAsCsv();"
    >
      Export Spreadsheet
    </button>
  </div>

  <ag-grid-angular
    style="width: 100%; height: 100%;"
    class="ag-theme-alpine"
    [rowData]="gridSource"
    [columnDefs]="gridColumns"
    pagination=true
    (gridReady)="onGridReady($event)"

  />
  
  <app-spinner [active]="loading"></app-spinner>
</div>